const carAudioAndMultimedia = [
    "Android Auto",
    "Apple CarPlay",
    "Bluetooth",
    "Dostęp do internetu",
    "Ekran dotykowy",
    "Gniazdo AUX",
    "Gniazdo SD",
    "Gniazdo USB",
    "HUD (wyświetlacz przezierny)",
    "MP3",
    "Nawigacja GPS",
    "Odtwarzacz DVD",
    "Radio fabryczne",
    "Radio niefabryczne",
    "Sterowanie funkcjami pojazdu za pomocą głosu",
    "System nagłośnienia",
    "Tuner TV",
    "Zestaw głośnomówiący",
    "Zmieniarka CD",
    "Ładowanie bezprzewodowe urządzeń",
]

const steeringWheelSupportSystems = [
    "ASR (kontrola trakcji)",
    "Aktywne rozpoznawanie znaków ograniczenia prędkości",
    "Asystent hamowania - Brake Assist",
    "Asystent jazdy w korku",
    "Asystent parkowania",
    "Asystent pasa ruchu",
    "Asystent pokonywania zakrętów",
    "Asystent zapobiegania kolizjom na skrzyzowaniu",
    "Asystent świateł drogowych",
    "Automatyczna kontrola zjazdu ze stoku",
    "Autonomiczny system kierowania",
    "Blokada mechanizmu różnicowego",
    "Czujnik deszczu",
    "Czujnik martwego pola",
    "Czujnik zmierzchu",
    "Czujniki parkowania przednie",
    "Czujniki parkowania tylne",
    "Dynamiczne światła doświetlające zakręty",
    "Elektroniczna kontrola ciśnienia w oponach",
    "Elektrycznie ustawiane lusterka",
    "Elektryczny hamulec postojowy",
    "Kamera cofania",
    "Kamera panoramiczna 360",
    "Kamera w lusterku bocznym",
    "Kontrola odległości od poprzedzającego pojazdu",
    "Lampy doświetlające zakręt",
    "Lampy tylne w technologii LED",
    "Lane assist - kontrola zmiany pasa ruchu",
    "Lusterka boczne składane elektrycznie",
    "Niezależny system parkowania",
    "Ogranicznik prędkości",
    "Oświetlenie adaptacyjne",
    "Oświetlenie drogi do domu",
    "Oświetlenie wnętrza LED",
    "Podgrzewane lusterka boczne",
    "Regulowany dyferencjał centralny",
    "Spryskiwacze reflektorów",
    "System Start-Stop",
    "System rozpoznawania znaków drogowych",
    "Tempomat",
    "Tempomat aktywny",
    "Wspomaganie kierownicy",
    "Wspomaganie ruszania pod górę- Hill Holder",
    "Światła LED",
    "Światła Xenonowe",
    "Światła do jazdy dziennej",
    "Światła do jazdy dziennej diodowe LED",
    "Światła przeciwmgielne",
]

const achievementsAndTuninig = [
    "Elektroniczna regul charakterystyki zawieszenia",
    "Filtr cząstek stałych",
    "Hamulce z kompozytów ceramicznych",
    "Opony Run Flat",
    "Regulowane zawieszenie",
    "Zawieszenie hydropneumatyczne",
    "Zawieszenie komfortowe",
    "Zawieszenie pneumatyczne",
    "Zawieszenie sportowe",
]

const forElectricCars = [
	'Funkcja szybkiego ładowania',
	'Kabel do ładowania',
	'System odzyskiwania energii',
]

const carSafety = [
    "ABS",
    "Aktywny system monitorowania kondycji kierowcy",
    "Alarm",
    "Alarm ruchu poprzecznego z tyłu pojazdu",
    "ESP (stabilizacja toru jazdy)",
    "Elektroniczny system rozdziału siły hamowania",
    "Immobilizer",
    "Isofix",
    "Kurtyny powietrzne",
    "Poduszka powietrzna centralna",
    "Poduszka powietrzna chroniąca kolana",
    "Poduszka powietrzna kierowcy",
    "Poduszka powietrzna pasażera",
    "Poduszka powietrzna pasów bezpieczeństwa",
    "Poduszki boczne przednie",
    "Poduszki boczne tylne",
    "System awaryjnego hamowania",
    "System chroniący przed kolizja, boczny",
    "System chroniący przed kolizja, tylny",
    "System emitujący dźwięk silnika (AVAS)",
    "System minimalizujący skutki kolizji",
    "System ochrony słuchu w przypadku kolizji",
    "System ostrzegający o możliwej kolizji",
    "System powiadamiania o wypadku",
    "System rekomendacji przerw podczas trasy",
    "System wykrywania zmęczenie kierowcy",
    "System zabezpieczający podczas dachowania",
]

const carComfort = [
    "Alufelgi",
    "Automatyczna kontrola ogrzewania",
    "Ogrzewanie postojowe",
    "Centralny zamek",
    "Cyfrowy kluczyk",
    "Dach otwierany elektrycznie",
    "Dach otwierany elektrycznie pilotem",
    "Dach panoramiczny",
    "Szyberdach",
    "Relingi dachowe",
    "Dźwignia zmiany biegów wykończona skórą",
    "Elektrochromatyczne lusterka boczne",
    "Elektrochromatyczne lusterko wsteczne",
    "Elektryczna klapa bagażnika",
    "Elektryczne szyby przednie",
    "Elektryczne szyby tylne",
    "Elektrycznie ustawiane fotele",
    "Fotele przednie z funkcją masażu",
    "Fotele tylne z funkcją masażu",
    "Hak",
    "Keyless Go",
    "Keyless entry",
    "Uruchamianie silnika bez użycia kluczyków",
    "Kierownica ogrzewana",
    "Kierownica skórzana",
    "Kierownica sportowa",
    "Łopatki zmiany biegów",
    "Kierownica ze sterowaniem radia",
    "Wielofunkcyjna kierownica",
    "Klimatyzacja automatyczna",
    "Klimatyzacja manualna",
    "Kolumna kierownicy regulowana elektrycznie",
    "Komputer pokładowy",
    "Podgrzewana przednia szyba",
    "Podgrzewane przednie siedzenia",
    "Podgrzewane tylne siedzenia",
    "Podłokietniki - przód",
    "Podłokietniki - tył",
    "Przyciemniane szyby",
    "Przyciemniane tylne szyby",
    "Regul elektr podparcia lędźwiowego - kierowca",
    "Regul elektr podparcia lędźwiowego - pasażer",
    "Siedzenie z pamięcią ustawienia",
    "Sportowe fotele - przód",
    "Tapicerka Alcantara",
    "Tapicerka częściowo skórzana",
    "Tapicerka materiałowa",
    "Tapicerka skórzana",
    "Tapicerka welurowa",
    "Wentylowane fotele",
    "Wentylowane fotele tył",
    "Wycieraczki",
]

const prefixes = [
    'bezpieczenstwo-',
    'komfort-',
    'audio-i-multimedia-',
    'systemy-wspomagania-kierownicy-',
    'osiagi-i-tuning-',
    'dla-samochodow-elektrycznych-',
]

const combined = [
	...carSafety,
	...carComfort,
	...carAudioAndMultimedia,
	...steeringWheelSupportSystems,
	...achievementsAndTuninig,
	...forElectricCars,
].sort()

export default combined
export {
    carSafety,
    carComfort,
	carAudioAndMultimedia,
	steeringWheelSupportSystems,
	achievementsAndTuninig,
	forElectricCars,

    prefixes,
}